import controller from '../field.controller';
import template from './hyperlinkField.html';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
